<template>
  <div>

    <b-navbar toggleable="md" type="dark" variant="primary">
      <b-navbar-brand to="/">
        RxPave
      </b-navbar-brand>
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

      <b-collapse is-nav id="nav_collapse">
        <b-navbar-nav class="mr-auto">
          <b-nav-item v-if="isLoggedIn">
            <router-link class="nav-link" to="/projects">
              My Projects
            </router-link>
          </b-nav-item>
          <b-nav-item v-if="isLoggedIn">
            <router-link class="nav-link" to="/account">
              My Account
            </router-link>
          </b-nav-item>
          <b-nav-item class="nav-link" href="https://rxpave.com/getting-started/" target="_blank">
              Getting Started
          </b-nav-item>
          <b-nav-item class="nav-link" href="https://rxpave.com/rxpave-resources/" target="_blank">
            Documentation
          </b-nav-item>
          <b-nav-item class="nav-link" href="https://rxpave.com/contact/" target="_blank">
              Contact Us
          </b-nav-item>

          <b-dropdown v-if="user.is_admin" text="Admin" variant="warning">
            <b-dropdown-item v-on:click="testSendToServer">
                Test Button
            </b-dropdown-item>
            <b-dropdown-item v-on:click="testCreateUser">
                Create User
            </b-dropdown-item>
            <b-dropdown-item v-on:click="testLogin">
                Login
            </b-dropdown-item>
            <b-dropdown-item v-on:click="testGetAvailableProjects">
                Load Projects
            </b-dropdown-item>
          </b-dropdown>
        </b-navbar-nav>

        <b-navbar-nav class="ml-auto">
          <b-nav-item>
            <b-btn-group>
              <b-button btn-primary v-b-modal.login-modal
                        v-if="user.email === null"
                        variant="brand">
                <font-awesome-icon :icon="['far','user']"/> Login
              </b-button>
              <b-button btn-primary @click="logoutUser" v-if="user.email !== null" variant="brand">
                <font-awesome-icon :icon="['far','user']"/> Logout
              </b-button>
            </b-btn-group>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>


    <div v-for="alert in alerts">
      <b-alert
          show
          dismissible
          :variant="alert.variant"
      >
      {{alert.message}}
    </b-alert>
  </div>


    <b-container fluid id="mainContainer">
     <router-view></router-view>
    </b-container>

    <!--<login-modal v-if="showModal" @close="showModal=false" >-->
      <!--</login-modal>-->
    <login-modal></login-modal>
  </div>
</template>

<script>
import LoginModal from "./LoginModal.vue";

import { mapActions, mapGetters } from 'vuex'
import { mapFields } from 'vuex-map-fields'
import { createHelpers } from 'vuex-map-fields'

// const {mapFields}= createHelpers({
//   getterType: 'user/getField',
//   mutationType: 'user/updateField'
// });

export default {
  name: "Main",
  components: {
    LoginModal
  },
  data: function() {
    return {
      showModal: false
    };
  },
  computed: {
    ...mapFields('account',[
      "user"
    ]),
    ...mapGetters('account', [
      'isLoggedIn',
      'displayMessages'
    ]),
    alerts() {
      return [
        // {message: 'Test Alert', variant:"warning", dismissed: false},
        // {message: 'Another test', variant: "info", dismissed: false}
      ]
    }
  },
  methods: {
    ...mapActions('account',[
      'createUser',
      'login',
      'logout'
    ]),
    ...mapActions('rx',[
      'saveProject',
      'getAvailableProjects'
    ]),
    testSendToServer: function (){
      console.log('Running test button actions');
      this.saveProject()
    },
    startLogin(){
      this.showModal = true;
    },
    testCreateUser(){
      console.log('Running create user');
      this.createUser();
    },
    testLogin(){
      console.log("Logging in");
      this.login();
    },
    testGetAvailableProjects(){
      this.getAvailableProjects()
    },
    logoutUser(){
      this.logout().then(() => this.$router.push('/'))
    }
  },
};

console.log("Loading Main Component");
</script>

<style scoped>
  body {
    /*font: 'Calibri', Verdana, sans-serif;*/
    margin: 0;
    padding: 0;
  }


.header-right p {
  bottom: -25px;
  font-size: 24px;
  position: absolute;
  right: 0;
  color: #000;
}

 .footer-logos img {
  height: 60px;
}

 /*
 May not show up in IDE as active in DOM but used nonetheless!
 */
 .alert {
   margin: 0;
 }


 /* Unused legacy css */

/*.router-link-active {*/
  /*color: red;*/
/*}*/

/*.fa-icon {*/
  /*fill: red;*/
/*}*/

/*.title {*/
  /*font-weight: bold;*/
  /*font-size: 1.5em;*/
  /*line-height: 80px;*/
  /*vertical-align: center;*/
/*}*/

/*#toolbar {*/
  /*height: 20px;*/
  /*padding-right: 20px;*/
  /*padding-left: 20px;*/
  /*background-color: #fafafa;*/
  /*background-image: linear-gradient(to bottom, #ffffff, #f2f2f2);*/
  /*background-repeat: repeat-x;*/
  /*border: 1px solid #d4d4d4;*/
  /*border-radius: 4px;*/
  /*box-shadow: 0 1px 4px rgba(0, 0, 0, 0.065);*/
  /*float: left;*/
  /*margin: 0 275px 20px 275px;*/
  /*max-width: 1105px;*/
/*}*/



/*.header-main {*/
  /*background: none repeat scroll 0 0 #ffffff;*/
  /*border-top: 8px solid #0115d6;*/
  /*margin: 0 auto;*/
  /*padding-top: 10px;*/
  /*position: relative;*/
  /*width: 100%;*/
  /*z-index: 2;*/
/*}*/
/*.footer-logos {*/
  /*background: #ddd;*/
  /*padding-top: 40px;*/
  /*padding-bottom: 40px;*/
/*}*/


/*.footer-inner {*/
  /*margin: 0 auto;*/
  /*!*width: 1170px;*!*/
/*}*/

/*.footer-bottom {*/
  /*min-height: 25px;*/
  /*background-color: #fff;*/
/*}*/

/*.footer-copyright {*/
  /*color: #ccc;*/
  /*width: 100%;*/
  /*padding: 5px;*/
  /*background-color: #343434;*/
/*}*/

/*.header {*/
  /*background: #fff;*/
  /*!*width: 1170px;*!*/
  /*margin: 0 auto;*/
/*}*/
/*.header-left {*/
  /*background: #fff;*/
/*}*/

/*.header-right {*/
  /*background: #fff;*/
  /*line-height: 70px;*/
  /*font-size: 1.2em;*/
  /*font-weight: bold;*/
  /*float: right;*/
/*}*/
/*.green-line {*/
  /*background-color: #0115d6;*/
  /*float: left;*/
  /*height: 7px;*/
  /*margin-top: 15px;*/
  /*width: 100%;*/
/*}*/

/*.footer {*/
  /*background: #4a7f46;*/
  /*!*width: 850px;*!*/
  /*margin: 0 auto;*/
  /*font-size: 15px;*/
/*}*/
/*.footer-left {*/
  /*background: #4a7f46;*/
  /*!*width: 750px;*!*/
  /*float: left;*/
  /*margin: 5px 0 0;*/
/*}*/

/*.footer-right {*/
  /*background: #4a7f46;*/
  /*!*width: 100px;*!*/
  /*height: 25px;*/
  /*float: right;*/
  /*text-align: right;*/
  /*margin: 5px 0 0;*/
/*}*/

/*.footer-main {*/
  /*!*border-top: 8px solid #0115d6;*!*/
  /*background-color: #ddd;*/
  /*margin-top: 20px;*/
  /*position: relative;*/
  /*width: 100%;*/
  /*!*height: 10rem;*!*/
/*}*/
</style>
